import FolderIcon from "../../assets/icons/svg/folder.svg";
import FileMERIcon from "../../assets/icons/svg/FileMER.svg";
import FallbackIcon from "../../assets/icons/svg/files.svg";
import _React from "react";

// Eager glob only specific patterns
const fileIcons = import.meta.glob("../../assets/icons/svg/File*.svg", {
  eager: true,
  import: "default",
});
const shortcutIcons = import.meta.glob("../../assets/icons/svg/filesShortcutIcons/Sfile*.svg", {
  eager: true,
  import: "default",
});

export function getFileImage(file: any): any {
  const ext = file?.name?.split(".").pop()?.toLowerCase();
  const extUpper = ext?.toUpperCase();

  if (file.isFolder) return FolderIcon;
  if (file.resourceType === "RESOURCE_TYPE_MERGED_FILE") return FileMERIcon;

  if (file.resourceType === "RESOURCE_TYPE_SHORTCUT_FILE") {
    const shortcutPath = `../../assets/icons/svg/filesShortcutIcons/Sfile${extUpper}.svg`;
    return shortcutIcons[shortcutPath] ?? FallbackIcon;
  }

  const dynamicPath = `../../assets/icons/svg/File${extUpper}.svg`;
  return fileIcons[dynamicPath] ?? FallbackIcon;
}
